<template>
  <div>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div v-show="!showPanel" class="double-left-btn">
        <a-icon
          style="font-size: 30px;color: white;cursor: pointer;"
          @click="showPanel = !showPanel"
          type="double-right"
        />
      </div>
    </transition>

    <transition
      name="slide"
      enter-active-class="animated slideInLeft"
      leave-active-class="animated slideOutLeft"
    >
      <div class="table-back-tile" v-show="showPanel">
        <a-icon
          @click="showPanel = !showPanel"
          style="color: gray;margin-top: 10px;font-size: 20px;cursor: pointer;position: absolute;right: 8px;z-index: 10;"
          type="double-left"
        />
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPanel: true
    };
  }
};
</script>

<style>
.table-back-tile {
  width: 790px;
}
@media screen and (max-width: 1366px) {
  .table-back-tile {
    width: 740px;
  }
}
</style>
